import React from "react";

class PrivacyPolicy extends React.Component {
  render() {
    return (
      <>
        <section id="breadcrumbs" className="breadcrumbs">
          <div className="container"></div>
        </section>

        <section id="PrivacyPolicy" className="PrivacyPolicy">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>Privacy Policy</h2>
            </div>

            <div className="row content">
              <div className="col-lg-12" data-aos="fade-up" data-aos-delay="150">

                <p><strong>Last Updated: 27-Nov-2025</strong></p>

                <p>
                  Welcome to <strong>AGM Etech Private Limited</strong> (“Company”, “we”, “our”, “us”).  
                  We are committed to protecting your privacy and ensuring transparency 
                  in how we operate.
                </p>

                <p>
                  This Privacy Policy explains how we handle information 
                  when you interact with our website:
                </p>

                <p><strong>Website:</strong> www.agmetech.com</p>
                <p><strong>Location:</strong> Gujarat, India</p>
                <p>
                  <strong>Services:</strong> IT Services, Software Development, Mobile App
                  Development, Website & Web App Development, Customized Software Solutions
                </p>

                <h4>1. Information We Do Not Collect</h4>
                <p>We do not collect:</p>
                <ul>
                  <li>Personal data such as name, email, phone number</li>
                  <li>Payment or financial information</li>
                  <li>Location data</li>
                  <li>Cookies or analytics data</li>
                  <li>Any data that identifies you personally</li>
                </ul>
                <p>You can browse our website freely and anonymously.</p>

                <h4>2. Third-Party Services</h4>
                <p>Our website currently does not use:</p>
                <ul>
                  <li>Analytics tools (e.g., Google Analytics)</li>
                  <li>Advertising trackers</li>
                  <li>Embedded login or data collection services</li>
                </ul>
                <p>
                  If we include such services in the future, this policy will be updated accordingly.
                </p>

                <h4>3. External Links</h4>
                <p>
                  Our website may contain links to third-party websites.  
                  We are not responsible for the privacy practices 
                  or content of those external websites.
                </p>

                <h4>4. Data Security</h4>
                <p>
                  Since no data is collected or stored, there is no personal information at risk.  
                  Our infrastructure and hosting providers maintain general security measures 
                  for the website.
                </p>

                <h4>5. Policy Updates</h4>
                <p>
                  We may update this Privacy Policy occasionally to reflect changes in functionalities 
                  or regulations. Any updates will be posted on this page with a new modification date.
                </p>

                <h4>6. Contact Us</h4>
                <p>If you have any questions about this Privacy Policy, please contact us:</p>
                <p><strong>AGM Etech Private Limited</strong></p>
                <p>Gujarat, India</p>
                <p>Email: info@agmetech.com</p>

              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default PrivacyPolicy;
    